<template>
  <div id="container">
    <div class="header">
      {{ title | capitalize }}
    </div>
    <!-- funds -->
    <a v-if="type === 'funds'" :href="downloadUrl">
      <div class="link-class download-link">{{ $t('downloadSampleFile') | capitalize }}</div>
    </a>

    <!-- pro-rata -->
    <div v-if="type === 'pro-rata'">
      <div class="link-class download-link" @click="download">
        {{ $t('downloadSampleFile') | capitalize }}
      </div>
      <div class="download-link">
        {{ $t('downloadSampleFileNote') }}
      </div>
    </div>

    <div id="dropzone-container">
      <vue2Dropzone
        id="dropzone"
        ref="myVueDropzone"
        :options="dropzoneOptions"
        :use-custom-slot="true"
        @vdropzone-removed-file="vremoved"
        @vdropzone-file-added="vfileAdded"
      >
        <div class="dropzone-custom-content">
          <div v-if="!fileAdded">
            <span class="upload-icon">
              <i class="far fa-file-upload" />
            </span>
            <div>{{ $t('chooseFileOrDrag') }}</div>
          </div>
        </div>
      </vue2Dropzone>
    </div>
    <div id="dropzone-modal-footer">
      <b-button
        :disabled="!this.fileAdded"
        style="font-weight:bold; width:120px;"
        size="sm"
        class="ml-4"
        variant="primary"
        @click="processQueue"
      >
        <spinner v-if="loading" />
        <span v-else>{{ $t('upload') | capitalize }}</span>
      </b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed;
}

.download-link {
  text-align: end;
  margin-bottom: 10px;
}

.upload-icon {
  color: #6b90a2;
  font-size: 28px;
}

.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

#container {
  padding: 0 50px 0 50px;
}

.header {
  margin: auto;
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 10px;
}

#dropzone-container {
  padding: 10px;
  background-color: #e1e9ec;
  border-radius: 4px;
}

#dropzone {
  padding: 10px;
  height: 280px;
  border: dashed 1px #6b90a2;
  border-radius: 4px;
}

#dropzone-modal-footer {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>

<style lang="scss">
.dz-error-mark {
  display: none;
}

.dz-success-mark {
  display: none;
}

.dz-preview .dz-file-preview {
  text-align: center;
}
</style>

<script>
import { ApiCalls, downloadFile } from "@/assets/libs/services"
import { api } from "@/main"
import vue2Dropzone from "vue2-dropzone"

export default {
  name: "Dropzone",
  components: {
    vue2Dropzone
  },
  computed: {},

  methods: {
    download () {
      api.get(this.downloadUrl, { responseType: "blob" })
        .then(res => {
          try {
            downloadFile(res.data, res.headers["content-disposition"].replace(/^attachment; filename=/, ""))
          } catch (error) {
            this.$toasted.global.toast(error)
          }
        })
        .catch(err => {
          this.$toasted.global.toast(err)
        })
    },
    vfileAdded () {
      const dropzone = this.$refs.myVueDropzone
      const file = dropzone.getQueuedFiles()[0]
      if (file) {
        dropzone.removeFile(file)
      }
      this.fileAdded = true
    },
    vremoved () {
      this.fileAdded = false
    },
    processQueue () {
      this.loading = true
      const dropzone = this.$refs.myVueDropzone
      const file = dropzone.getAcceptedFiles()[0]
      if (file) {
        ApiCalls.sendFile(file, this.uploadUrl, this.method)
          .then(() => {
            this.loading = false
            this.$toasted.global.toast(this.$t("file_uploaded"))
            dropzone.removeAllFiles()
            this.$emit("success", file)
            this.$emit("closeModal")
          })
          .catch(err => {
            if (err.response && err.response.status === 406) {
              this.loading = false
              const errors = {
                ingestion: err.response.data.stats.ingestion.errors,
                loading: err.response.data.stats.loading.errors,
                parsing: err.response.data.stats.parsing.errors
              }
              this.$emit("error", errors)
              this.$emit("closeModal")

            } else {
              this.loading = false
              this.$toasted.global.toast(err)
            }
          })
      }
    }
  },

  props: {
    title: {
      type: String,
      required: true
    },
    method: {
      type: String
    },
    type: {
      type: String
    },
    downloadUrl: {
      type: String,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      fileAdded: false,
      loading: false,
      dropzoneOptions: {
        url: "empty",
        autoProcessQueue: false,
        addRemoveLinks: true,
        maxFiles: 1
      }
    }
  }
}
</script>
